import axios from "axios";

const API_URL = "https://smallties.com"; // Replace with your deployed server URL for production
// const API_URL = "http://localhost:3000"; // Replace with your deployed server URL for production

export const addWaitlister = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/api/waitlister`, data);
    return response.data;
  } catch (error) {
    console.error("Error adding waitlister:", error);
    throw error;
  }
};

export const getWaitlisters = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/waitlister`);
    return response.data;
  } catch (error) {
    console.error("Error fetching waitlisters:", error);
    throw error;
  }
};

export const getVotes = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/vote`);
    return response.data;
  } catch (error) {
    console.error("Error fetching votes:", error);
    throw error;
  }
};

export const addVote = async (data) => {
  try {
    // API call to increment the vote count for the selected counter
    const response = await axios.post(`${API_URL}/api/vote`, data);
    return response.data;
  } catch (error) {
    console.error("Error voting for the benefit:", error);
  }
};
